<div class="ft-visualization-guestfeedbackrating">
    <div class="ft-meter">
        @for (rating of ratings(); track rating) {
            <div class="ft-rating-{{rating.rating}}"
                 [style.width.%]="rating.percentage">
                <div class="ft-meter-info-bubble">
                    <span class="ft-count">{{rating.total}}</span>
                </div>
            </div>
        }
    </div>
    <div class="ft-meter-labels">
        <div class="ft-meter-label-0">
            <span class="ft-count">0</span> Not likely
        </div>
        <div class="ft-meter-label-5">
            Absolutely will <span class="ft-count">5</span>
        </div>
    </div>
</div>
